import React, { useState } from 'react';
import cn from 'classnames';
import Link from 'next/link';

import Accordion from 'react-scale/components/pages/docs/Accordion';

const Sidebar = ({ topLevelNavigation, subLevelNavigation, slug, openHeaderMobile }) => {
  const [isOpen, setOpen] = useState(false);

  const toggle = (index, show) => {
    if (!show) {
      setOpen(index);
    } else {
      setOpen(false);
    }
  };

  return (
    <div className="lg:pr-9">
      <div
        className={cn(
          'lg:sticky lg:top-[81px] lg:h-[calc(100vh-81px)] overflow-y-auto lg:py-14 lg:pr-4 lg:block lg:w-72 lg:pb-0 pb-8',
          openHeaderMobile ? 'block' : 'hidden'
        )}
      >
        <div className="mb-4">
          <Link
            href="/docs"
            className="flex items-center gap-3 text-base font-normal cursor-pointer text-neutral-900 dark:text-neutral-300 group"
          >
            <span className="p-2 border rounded-lg border-zinc-200 dark:border-zinc-800">
              {homeIcon}
            </span>
            <p className="duration-300 transition-color group-hover:opacity-80 whitespace-nowrap">
              Home
            </p>
          </Link>
        </div>
        {topLevelNavigation
          .sort((a, b) => a.order - b.order)
          .map((item, i) => (
            <div
              className={cn('mb-4 last:mb-0', { 'lg:mb-10': item.order === 0 })}
              key={item.order}
            >
              <Accordion
                title={item.title}
                items={subLevelNavigation[i]}
                // show={isOpen === i || subLevelNavigation[i].find(e => e.slug === slug)}
                show={isOpen === i}
                slug={slug}
                index={i}
                toggle={toggle}
                parent={item}
              />
            </div>
          ))}
        <div className="lg:mt-10">
          <Link
            href="https://docs.scale.com/reference"
            className="flex items-center gap-3 text-base font-normal cursor-pointer text-neutral-900 dark:text-neutral-300 group"
          >
            <span className="p-2 border rounded-lg border-zinc-200 dark:border-zinc-800">
              {apiIcon}
            </span>
            <p className="duration-300 transition-color group-hover:opacity-80">API Reference</p>
            <svg
              className="ml-1 fill-current text-neutral-900 dark:text-neutral-300"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginTop: 1 }}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.5 10.25C11.2239 10.25 11 10.0261 11 9.75V5.71122L4.85002 11.8612C4.65618 12.0559 4.34126 12.0565 4.14663 11.8626C3.952 11.6688 3.95137 11.3539 4.14522 11.1592C4.14666 11.1578 4.14811 11.1564 4.14957 11.1549L10.3045 5H6.25002H6.25002C5.97388 5 5.75002 4.77614 5.75002 4.5C5.75002 4.22386 5.97388 4 6.25002 4H11.5C11.7762 4 12 4.22386 12 4.5V9.75C12 10.0261 11.7762 10.25 11.5 10.25L11.5 10.25Z"
              />
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const homeIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.7 12.7C21.5 12.9 21.3 13 21 13C20.7 13 20.5 12.9 20.3 12.7L12 4.4L3.7 12.7C3.3 13.1 2.7 13.1 2.3 12.7C1.9 12.3 1.9 11.7 2.3 11.3L11.3 2.3C11.7 1.9 12.3 1.9 12.7 2.3L21.7 11.3C22.1 11.7 22.1 12.3 21.7 12.7ZM18 13C17.4 13 17 13.4 17 14V19H7V14C7 13.4 6.6 13 6 13C5.4 13 5 13.4 5 14V20C5 20.6 5.4 21 6 21H18C18.6 21 19 20.6 19 20V14C19 13.4 18.6 13 18 13Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="2"
        y1="11.4959"
        x2="22.0018"
        y2="11.4959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1AAD7" />
        <stop offset="0.25" stopColor="#C88BC4" />
        <stop offset="0.5" stopColor="#7B8FDD" />
        <stop offset="0.7486" stopColor="#86BFF2" />
        <stop offset="0.9987" stopColor="#BBDEF2" />
      </linearGradient>
    </defs>
  </svg>
);

export const apiIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.9 13L19.2 12L20.9 11C21.6 10.6 22 9.79995 22 8.89995C22 7.99995 21.6 7.19995 20.9 6.79995L13.6 2.39995C12.6 1.79995 11.5 1.79995 10.5 2.39995L3.1 6.79995C2.4 7.19995 2 7.99995 2 8.89995C2 9.79995 2.4 10.6 3.1 11L4.8 12L3.1 13C2.4 13.4 2 14.2 2 15.1C2 16 2.4 16.8 3.1 17.2L10.4 21.6C10.9 21.9 11.4 22 11.9 22C12.4 22 13 21.9 13.4 21.6L20.7 17.2C21.4 16.8 21.8 16 21.8 15.1C21.8 14.2 21.6 13.4 20.9 13ZM4.2 9.29995C4.1 9.19995 4 9.09995 4 8.89995C4 8.69995 4.1 8.59995 4.2 8.49995L11.5 4.09995C11.6 3.99995 11.8 3.99995 12 3.99995C12.2 3.99995 12.4 4.09995 12.5 4.19995L19.8 8.59995C19.9 8.59995 20 8.69995 20 8.89995C20 9.09995 19.9 9.19995 19.8 9.29995L17.2 10.9L13.5 8.69995C12.5 8.09995 11.4 8.09995 10.4 8.69995L6.7 10.9L4.2 9.29995ZM15.3 12L12.6 13.6C12.3 13.8 11.9 13.8 11.6 13.6L8.7 12L11.4 10.4C11.6 10.3 11.7 10.2 11.9 10.2C12.1 10.2 12.3 10.3 12.4 10.4L15.3 12ZM19.8 15.5L12.5 19.9C12.2 20.1 11.8 20.1 11.4 19.9L4.1 15.5C4.1 15.4 4 15.3 4 15.1C4 14.9 4.1 14.8 4.2 14.7L6.8 13.1L10.5 15.3C11 15.6 11.5 15.7 12 15.7C12.5 15.7 13.1 15.6 13.5 15.3L17.2 13.1L19.8 14.7C19.9 14.8 20 14.9 20 15.1C20 15.3 19.9 15.4 19.8 15.5Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="2"
        y1="11.9706"
        x2="22.0018"
        y2="11.9706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1AAD7" />
        <stop offset="0.25" stopColor="#C88BC4" />
        <stop offset="0.5" stopColor="#7B8FDD" />
        <stop offset="0.7486" stopColor="#86BFF2" />
        <stop offset="0.9987" stopColor="#BBDEF2" />
      </linearGradient>
    </defs>
  </svg>
);

export default Sidebar;
